import {
  delay,
  http,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { QrImageDownloadResponse } from '@/repositories/generated';

const response: QrImageDownloadResponse = {
  presignedUrl: 'https://example.com',
};

export const qrDownload = http.get(
  createMockEndpoint('/terminal/:id/download/qr'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
